module.exports = __webpack_public_path__ + "img/漏斗图.a769eeab.png";